"use client";

import { type Context, useContext } from "react";

/**
 * Like useContext but enforces that the context is non null
 */
export function useContextStrict(UserContext) {
  const context = useContext(UserContext);
  if (context === null) {
    const name = UserContext.displayName || "Context";
    throw new Error(`no useContext(${name}), did you use <${name}.Provider>?`);
  }
  return context;
}